import { Warning } from "../icons";
import Modal from "./Modal";

export default function DeleteModal({ open, onClose, onCreate, modalName }) {
  function handleDelete() {
    onCreate?.();
    onClose?.();
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={null}
      panelClassName="max-w-[448px] !min-h-[218px]  rounded-xl"
      centered={false}
    >
      <div className="w-full">
        <div className="flex items-center gap-3  mb-4">
          <div className="rounded-full h-12 w-12 bg-[#FEE2E2] flex items-center justify-center">
            <Warning />
          </div>
          <div>
            <p className="text-lg  text-[#111827] font-bold">Delete {modalName}</p>
            <p className="text-sm  text-[#4B5563]">
              This action cannot be undone
            </p>
          </div>
        </div>

        <p className="text-sm text-[#374151] leading-10">Are you sure you want to delete this {modalName}</p>

    
          <div className="mt-6 grid grid-cols-2 gap-3">
            <button
              onClick={onClose}
              className="text-[#374151] border border-[#E5E7EB] py-1 font-medium text-sm rounded-lg"
            >
             Cancel
            </button>

            <button
              onClick={handleDelete}
              className="bg-[#DC2626] text-white py-[11px] font-medium text-sm rounded-lg"
            >
              Delete {modalName}
            </button>
          </div>
      
      </div>
    </Modal>
  );
}
